import styled from 'styled-components';

import { orange1 } from 'approot/shared/styles/colours.style';
import { mediaUp, rem } from 'approot/shared/style';
import { spacing40, spacing8 } from 'approot/shared/styles/spacing.style';
import { borderRadius16 } from 'approot/shared/styles/borders.style';
import { Box } from 'approot/shared/design-system/box/box.style';

export const ActivitySampleBanner = styled(Box).attrs({
  $justifyContent: 'center',
  $alignItems: 'center',
})`
  border-radius: ${rem(borderRadius16)} ${rem(borderRadius16)} 0 0;
  padding: ${rem(spacing8)};
  background-color: ${orange1};
  min-height: ${rem(44)};
  padding-right: ${rem(spacing40)};

  ${mediaUp.md`
    padding-right: ${rem(34)};
  `}
`;
